import Vue from 'vue'
import Vuex from 'vuex'
import $mapStore from './store/mapStore.js'
import $searchStore from './store/searchStore.js'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        //店铺活动列表
        ACTIVITY_DATA: [],

        //poi 详情列表
        POI_DETAIL_DATA: [],

        //主题活动列表
        THEME_ACTIVITY_DATA:[[],[]],//第一个表示有效 第二个表示已结束

        ACTIVITY_DATA_DETEIL:'',    //活动详情

        NAVAREAPOINT_DATA:[],       //区域触发列表

        RecommendData:'',           //推荐项

        hot_Word:[],                //热词

        CollectData:[],             //收藏夹

        HistoryData:[],             //历史足迹

        appLoad:0,                  //0未开启 1：动画1 2：动画2 99：关闭动画

        escapeState:false,          //开启逃生

        retrievalTracking:{         //检索跟踪
            state:false,
            NAME:'',
            CATEGORY_ID:''
        },

        park_NullData:[],

    },
    //分模块处理
    modules:{
        mapStore: $mapStore,
        searchStore: $searchStore

    }
})
